<template>
	<div class="wai">
		<div class="title">
			<div class="blue"></div>
			<div style="flex: 1;">门店档案</div>
			<el-button @click="goback()" size="small">返 回</el-button>
			<el-button size="small" @click="getlist()">
				<i class="el-icon-refresh"></i> 刷 新
			</el-button>
		</div>
		<!-- 第三部分开始 -->
		<div class="demo">
			<div class="demoleft">
				<div class="demomsg">
					<div style="margin-top: 15px;">{{store.storeName}}</div>
					<div class="flex">
						<div></div><!--占位div -->
						<div style="margin-top: 10px;">店长: {{store.manager}}</div>
						<!-- <div style="margin-top: 10px;margin-left: 15px;">人员数量: {{store.haircut}}</div> -->
					</div>
				</div>
			</div>
			<div class="demoright">
				<div class="demorights">
					<div>{{summaryList.count}}</div>
					<div>累计服务订单数</div>
				</div>
				<div class="demorights">
					<div>{{(summaryList.marketTotal * 1).toFixed(2)}}</div>
					<div>累计营销收入</div>
				</div>
				<div class="demorights">
					<div>{{summaryList.member}}</div>
					<div>累计会员数</div>
				</div>
				<div class="demorights">
					<div>{{summaryList.customer}}</div>
					<div>累计服务用户数</div>
				</div>
			</div>
		</div>
		<!--  -->
		<div class="mouthtable" v-loading="loading">
			<!--  -->
			<div class="mouthtable_top">
				<div class="mouthtable_top_left">
					<!-- <div class="title" style="margin-right: 10px;margin-top: 3px;">
						等级
					</div>
					<el-select v-model="type" @change="getlist()" size="small" style="width: 180px;margin-right:10px;"
						placeholder="全部">
						<el-option v-for="item in options" :key="item.label" :label="item.label" :value="item.value">
						</el-option>
					</el-select> -->
					<div class="title" style="margin-right: 10px;margin-top: 3px;">
						月份
					</div>
					<div style="margin-right: 10px;">
						<el-date-picker @change="getlist()" clearable type="monthrange" value-format="yyyy-MM"
							v-model="month" size="small" style="margin-left: 10px;" placeholder="选择月份"></el-date-picker>
					</div>
					<el-button size="mini" type="primary" @click="getlist">筛 选</el-button>
					<el-button size="mini" type="primary" @click="export01()">导 出</el-button>
					<el-popover placement="top-start" title="说明" width="250" trigger="hover"
						content="会员销售数=非会员购买澳宝+19.9会员">
						<el-button size="medium" slot="reference" style="margin-left: 10px;">说明</el-button>
					</el-popover>
					<!-- 					<el-popover placement="top-start" title="说明"  width="200" trigger="click" content="非会员购买澳宝+19.9会员">
						<el-button size="medium" slot="reference">说明</el-button>
					</el-popover> -->
				</div>
			</div>
			<el-table :cell-style="{'text-align':'center','font-size':'16px'}"
				:header-cell-style="{background:'#F2F2F4','text-align':'center','color':'#6a6a6a','font-size':'18px'}"
				ref="multipleTable" :data="list" tooltip-effect="dark" style="width: 100%">
				<el-table-column prop="month" label="月份"></el-table-column>
				<el-table-column label="订单数">
					<template slot-scope="scope">
						{{scope.row.count==null?'0':scope.row.count}}
					</template>
				</el-table-column>
				<el-table-column label="客数">
					<template slot-scope="scope">
						{{scope.row.customer==null?'0':scope.row.customer}}
					</template>
				</el-table-column>
				<el-table-column label="业绩" prop="total" sortable>
					<template slot-scope="scope">
						{{scope.row.total==null?'0':scope.row.total.toFixed(2)}}
					</template>
				</el-table-column>
				<el-table-column label="剪发新/老客数">
					<template slot-scope="scope">
						{{scope.row.newHair==null?'0':scope.row.newHair}}/{{scope.row.oldHair==null?'0':scope.row.oldHair}}
					</template>
				</el-table-column>
				<el-table-column label="套餐新/老客数">
					<template slot-scope="scope">
						{{scope.row.newMember==null?'0':scope.row.newMember}}/{{scope.row.oldMember==null?'0':scope.row.oldMember}}
					</template>
				</el-table-column>
				<el-table-column label="新客数月同比">
					<template slot-scope="scope">
						<div v-if="scope.row.newCustomerRate < 0" class="content Red">{{scope.row.newCustomerRate}}%
						</div>
						<div v-else class="content Green">
							{{scope.row.newCustomerRate?"+"+scope.row.newCustomerRate+"%":'0'}}</div>
					</template>
				</el-table-column>
				<el-table-column label="本月成本" prop="chengben" sortable>
					<template slot-scope="scope">
						{{scope.row.chengben==null?'0':scope.row.chengben}}
					</template>
				</el-table-column>
				<el-table-column label="本月盈利" prop="yingli" sortable>
					<template slot-scope="scope">
						<div v-if="scope.row.yingli < 0" class="content Red">{{scope.row.yingli}}</div>
						<div v-else class="content Green">{{scope.row.yingli?scope.row.yingli:'0'}}</div>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagewai" style="text-align: center;margin-top: 20px;">
				<div class="paging">
					<el-pagination @current-change="handlePageChange" @size-change="handleSizeChange" background
						layout="sizes,prev, pager, next" :page-count="pageNo" :page-sizes="[10, 20, 30, 50, 100]"
						:page-size="pageSize" :total="total">
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		url
	} from '../../../utils/index.js'
	export default {
		data() {
			return {
				url: url(),
				store: {},
				loading: false,
				type: "",
				month: [],
				list: [],
				pageNo: 1,
				pageSize: 50,
				total: 0,
				usertotal: "",
				ordertotal: "",
				moneytotal: "",
				membertotal: "",
				options: [{
					value: "",
					label: "全部"
				}, {
					value: "S",
					label: "S"
				}, {
					value: "A",
					label: "A"
				}, {
					value: "B",
					label: "B"
				}, {
					value: "C",
					label: "C"
				}, {
					value: "D",
					label: "D"
				}],
				summaryList: {
					count: 0,
					marketTotal: 0,
					member: 0,
					customer: 0,
				}
			}
		},
		mounted() {
			this.store = JSON.parse(localStorage.getItem('storeFile'))
			this.getlist()
			// this.getSummary()
		},
		filters: {
			numFilter(value) { //不四舍五入
				let realVal = ''
				if (value !== '' && value != null && !isNaN(value)) {
					// 截取当前数据到小数点后三位
					let tempVal = parseFloat(value).toFixed(3)
					realVal = tempVal.substring(0, tempVal.length - 1)
				} else {
					realVal = '/'
				}
				return realVal
			},
			numFilter2(value) { //四舍五入
				let realVal = ''
				if (value !== '' && value != null && !isNaN(value)) {
					// 截取当前数据到小数点后两位
					realVal = parseFloat(value).toFixed(2)
				} else {
					realVal = '/'
				}
				return realVal
			}
		},
		methods: {
			getlist() {
				this.loading = true
				var str = this.$route.query.id + "&content=monthDesc" + "&pageNum=" + this.pageNo + "&pageSize=" + this
					.pageSize
				if (this.month != null && this.month.length > 0) {
					str += "&startTime=" + this.month[0] + "&endTime=" + this.month[1];
				} else {
					str = str;
				}
				this.$http.get("dStoreFile/list?storeId=" + str).then(res => {
					var list = res.body.data
					this.list = list
					this.summaryList.count = 0
					this.summaryList.marketTotal = 0
					this.summaryList.member = 0
					this.summaryList.customer = 0
					list.forEach(e => {
						this.summaryList.count += e.count
						this.summaryList.marketTotal += e.marketTotal
						this.summaryList.member += e.member
						this.summaryList.customer += e.customer
					})
					this.total = res.body.total
					this.loading = false
				})
			},
			// getSummary() {
			// 	this.$http.get("dWorkerFile/summary?workerId=" + this.$route.query.id).then(res => {
			// 		this.summaryList = res.body.data
			// 	})
			// },
			export01() {
				var str = "?storeId=" + this.$route.query.id + "&content=monthDesc" + "&pageNum=" + this.pageNo +
					"&pageSize=" + this.pageSize
				if (this.month != null && this.month.length > 0) {
					str += "&startTime=" + this.month[0] + "&endTime=" + this.month[1];
				} else {
					str = str;
				}
				window.location.assign(this.url + "dStoreFile/exportDetail" + str)
			},
			goback() {
				this.$router.push({
					path: '/storeData',
				})
			},
			handlePageChange(val) {
				this.pageNo = val
				this.getlist()
			},
			handleSizeChange(val) {
				this.pageSize = val
				this.getlist()
			}
		}
	}
</script>

<style lang="less" scoped>
	.wai {
		min-height: 80vh;
	}

	.flex {
		display: flex;
	}

	.Green {
		color: #008855;
	}

	.Red {
		color: #AA1111
	}

	.title {
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3E3E3E;
		display: flex;
		font-weight: bold;
		margin-bottom: 10px;

		.blue {
			width: 5px;
			height: 15px;
			background: #409EFF;
			border-radius: 2px;
			margin-right: 8px;
			position: relative;
			top: 4px;
		}
	}

	.title2 {
		margin-top: 30px;
		margin-bottom: 30px;
	}

	// 第二部分
	.demo {
		display: flex;
		width: 100%;
		height: 166px;
		background: #FFFFFF;
		box-shadow: 2px 2px 4px 2px rgba(102, 102, 102, 0.5);
		margin-top: 8px;
		box-sizing: border-box;
		padding: 20px;

		.demoleft {
			width: 33%;
			display: flex;
			border-right: 1px solid #bcbcbc;

			img {
				width: 105px;
				height: 105px;
				margin-top: 10px;
				border-radius: 50%;
			}

			.demomsg {
				margin-left: 25px;

				div:nth-child(1) {
					font-size: 26px;
					font-family: SourceHanSansCN-Bold, SourceHanSansCN;
					font-weight: bold;
					color: #2D2D2D;
					margin-top: 9px;
				}

				div:nth-child(n+2) {
					margin-top: 5px;
					font-size: 16px;
					font-family: SourceHanSansCN-Normal, SourceHanSansCN;
					font-weight: 400;
					color: #898989;
				}
			}
		}

		.demoright {
			display: flex;
			width: 90%;

			div {
				text-align: center;
				flex: 1;

				div:nth-child(1) {
					font-size: 36px;
					font-family: SourceHanSansCN-Bold, SourceHanSansCN;
					font-weight: bold;
					color: #2D2D2D;
					margin-top: 25px;
				}

				div:nth-child(2) {
					font-size: 16px;
					font-family: SourceHanSansCN-Normal, SourceHanSansCN;
					font-weight: 400;
					color: #0D0D0D;
				}
			}
		}
	}

	.mouthtable {
		margin-top: 25px;
		width: 100%;
		height: auto;
		background: #FFFFFF;
		box-shadow: 2px 2px 4px 2px rgba(102, 102, 102, 0.5);
		box-sizing: border-box;
		padding: 20px;

	}

	.mouthtable_top {
		margin-bottom: 10px;
		display: flex;

		.mouthtable_top_left {
			display: flex;
			flex: 1;
		}
	}
</style>